import { render, staticRenderFns } from "./DashboardGrid.vue?vue&type=template&id=4a3f8757&scoped=true&"
import script from "./DashboardGrid.vue?vue&type=script&lang=ts&"
export * from "./DashboardGrid.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardGrid.vue?vue&type=style&index=0&id=4a3f8757&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3f8757",
  null
  
)

export default component.exports